import React from 'react';

const LinkedinLogo = ({ ...props }) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.69643 31V10.9777H1.46875V31H7.69643ZM4.61607 8.23214C5.55357 8.23214 6.42411 7.89732 7.16071 7.16071C7.83036 6.49107 8.23214 5.62054 8.23214 4.61607C8.23214 3.67857 7.83036 2.80804 7.16071 2.07143C6.42411 1.40179 5.55357 1 4.61607 1C3.61161 1 2.74107 1.40179 2.07143 2.07143C1.33482 2.80804 1 3.67857 1 4.61607C1 5.62054 1.33482 6.49107 2.07143 7.16071C2.74107 7.89732 3.61161 8.23214 4.61607 8.23214ZM31 31V20.0179C31 16.9375 30.5312 14.6607 29.6607 13.1875C28.4554 11.3795 26.4464 10.442 23.567 10.442C22.0938 10.442 20.8884 10.8438 19.817 11.5134C18.8125 12.1161 18.0759 12.8527 17.6741 13.7232H17.6071V10.9777H11.6473V31H17.808V21.0893C17.808 19.5491 18.0089 18.3438 18.4777 17.5402C19.0134 16.4688 20.0179 15.933 21.4911 15.933C22.8973 15.933 23.8348 16.5357 24.3705 17.7411C24.6384 18.4777 24.7723 19.6161 24.7723 21.2232V31H31Z"
      fill="#003E7D"
    />
  </svg>
);

export default LinkedinLogo;
